import { NumberFormField } from './NumberFormField';

export const MoneyFormField = ({ fieldDef }) => {
  return <NumberFormField fieldDef={fieldDef} prefix="$" />;
}
